import { createContext, type ReactNode, useContext } from "react";

type ChatNotificationContextValue = {
  setChatUnread: (count: number) => void;
};

const ChatNotificationContext = createContext<ChatNotificationContextValue | null>(null);

export const ChatNotificationProvider = ({
  value,
  children,
}: {
  value: ChatNotificationContextValue;
  children: ReactNode;
}) => (
  <ChatNotificationContext.Provider value={value}>
    {children}
  </ChatNotificationContext.Provider>
);

export const useChatNotification = () => {
  const context = useContext(ChatNotificationContext);
  if (!context) {
    throw new Error(
      "useChatNotification must be used within a ChatNotificationProvider"
    );
  }
  return context;
};

